export default __webpack_public_path__ + "static/media/Law and Order.93bf2da3.png";